import React from 'react';

function CartIcon({ className = '' }) {
	return (
		<svg
			className={className}
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M19.3448 11.9652C18.9481 12.6885 18.1781 13.1668 17.3031 13.1668H8.61146L7.32813 15.5002H21.3281V17.8335H7.32813C5.55479 17.8335 4.43479 15.9318 5.28646 14.3685L6.86146 11.5218L2.66146 2.66683H0.328125V0.333496H4.14313L5.23979 2.66683H22.5065C23.3931 2.66683 23.9531 3.6235 23.5215 4.3935L19.3448 11.9652ZM20.5231 5.00016H6.34812L9.11312 10.8335H17.3031L20.5231 5.00016ZM7.32813 19.0002C6.04479 19.0002 5.00646 20.0502 5.00646 21.3335C5.00646 22.6168 6.04479 23.6668 7.32813 23.6668C8.61146 23.6668 9.66146 22.6168 9.66146 21.3335C9.66146 20.0502 8.61146 19.0002 7.32813 19.0002ZM16.6731 21.3335C16.6731 20.0502 17.7115 19.0002 18.9948 19.0002C20.2781 19.0002 21.3281 20.0502 21.3281 21.3335C21.3281 22.6168 20.2781 23.6668 18.9948 23.6668C17.7115 23.6668 16.6731 22.6168 16.6731 21.3335Z'
				fill='#545454'
			/>
		</svg>
	);
}

export default CartIcon;
